import axios from '../../../utils/api'
import { CLEAR_CADASTRO, SET_CADASTRO_ORIGINAL } from '../../mutation-types'

const state = {
  cadastroOriginal: {}
}

const getters = {
  cadastroOriginal: state => state.cadastroOriginal
}

const mutations = {
  [CLEAR_CADASTRO] (state, emptyCadastro) {
    Object.assign(state, emptyCadastro)
  },
  [SET_CADASTRO_ORIGINAL] (state, cadastroOriginal) {
    Object.assign(state.cadastroOriginal, cadastroOriginal)
  }
}

const actions = {
  async salvarCadastro ({ commit }, cadastro) {
    const result = await axios({
      method: 'POST',
      url: 'cadastroRetificacao/salvar',
      data: cadastro
    })

    return result
  },

  async excluirCadastroEmRetificacao ({ commit }, idProcesso) {
    const result = await axios({
      method: 'DELETE',
      url: `cadastroRetificacao/deleteCadastroEmRetificacaoByIdProcesso/${idProcesso}`
    })
    return result
  },

  async salvarCadastroByIdProcesso ({ commit }, payload) {
    const result = await axios({
      method: 'POST',
      url: `cadastroRetificacao/salvarById/${payload.idProcesso}`,
      data: payload.cadastro
    })

    return result
  },

  async finalizarRetificacao ({ commit }, payload) {
    const result = await axios({
      method: 'POST',
      url: `cadastroRetificacao/finalizarRetificacao/${payload.idProcesso}`,
      data: payload.json
    })

    return result
  },

  async cancelarRetificacao ({ commit }, idProcesso) {
    const result = await axios({
      method: 'POST',
      url: `cadastroRetificacao/cancelarRetificacao/${idProcesso}`
    })

    return result
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/cadastroRetificacao.js